// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

import { ESTADO } from '../MainPresupuestador.constants'

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  loadItemNuevoPending: false,
  loadItemNuevoError: null,
  nuevo: null,
  modalDeReserva: {
    steps: [],
    currentStep: {},
    modalActive: false,
  },
  validateBonificacionVendedorPending: false,
  validateBonificacionVendedorError: null,
  validateCostoPatentamientoPending: false,
  validateCostoPatentamientoError: null,
  costoPatentamientoValidation: {},
  cotizaciones: [],
  entregaUsados: [],
  Taking_cars: [],
  peritaciones: {},
  getLineasFinancierasPending: true,
  getLineasFinancierasError: null,
  savePresupuestoPending: false,
  savePresupuestoError: null,
  generateSellRequestPending: false,
  generateSellRequestError: null,
  updateStatePresupuestoPending: false,
  updateStatePresupuestoError: null,
  solicitarPeritajePending: false,
  solicitarPeritajeError: null,
  listaDePresupuestosPending: false,
  listaDePresupuestosError: null,
  selectedLineaFinanciera: null,
  lineasFinancieras: [],
  saveClientPending: false,
  saveClientError: null,
  controlClientError: null,
  getPdfPending: false,
  getPdfError: null,
  listaDePresupuestosPagination: {},
  dataList: null, //esta variable se usa para el componente List
  montoAfinanciar: 0,
  cuotasAfinanciar: 12,
  getCuotaPromedioAndCftPending: false,
  getCuotaPromedioAndCftError: null,
  sendEmailPending: false,
  sendEmailError: null,
  getPresupuestoPending: false,
  getPresupuestoError: null,
  clienteSirenaPending: false,
  clienteSirenaError: null,
  deleteBudgetPending: false,
  deleteBudgetError: null,
  state: ESTADO.BORRADOR,
  is_reservation: false,
  is_nulled: false,
  reservedColors: null,
  costoPatentamiento: 0,
  costoPatentamientoOriginal: null,
  resetCostoPatentamiento: false,
  observation: '',
  selectedBusinessUnit: null,
  selectedStock: null,
  will_get_costs: false,
  solicitudPendiente: false,
  remainder: 0,
  reportFilePresupeustadorSuccess: false,
  reportFilePresupuestoPending: false,
  reportFilePresupeustadorError: null,
  changeAmount: false,
  disableSave: false,
  alerts: [],
  sortFinancialLine: 'TASA',
  savePresupuestoSuccess: null,
  integration_car_lot_id: null,
  integration_branch_office_id: null,
  integration_branch_office_name: null,
  selectedBranchOffice: null,
  errorAmount: false,
  patenteCodeError: null,
  bonificationAvailable: 0,
  resale_price_increase: 0,
  payments_methods: [],
}

export default initialState
